import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSync = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const setHtmlLang = (lng) => {
      document.documentElement.lang = (lng || 'fr').split('-')[0];
    };
    setHtmlLang(i18n.resolvedLanguage || i18n.language);
    i18n.on('languageChanged', setHtmlLang);
    return () => i18n.off('languageChanged', setHtmlLang);
  }, [i18n]);

  return null;
};

export default LanguageSync;
